import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import madeInFranceImage from "../../../assets/smartbuilding/MadeInFrance.jpg";
import ProductCard from "../../products/productCaroussel/ProductCard";
import ProductCarousel from "../../products/productCaroussel/ProductCarrousel";
import COMMAND_1 from "../../../assets/products/COMMAND_1.png";
import CONTROLLERDIN_1 from "../../../assets/products/CONTROLLERDIN_1.png";
import MULTISWITCHDIN_1 from "../../../assets/products/MULTISWITCHDIN_1.png";
import SWITCHDIN_1 from "../../../assets/products/SWITCHDIN_1.png";
import MULTISWITCH_1 from "../../../assets/products/MULTISWITCH_1.png";
import MULTISWITCH_2 from "../../../assets/products/MULTISWITCH_2.png";
import SWITCH_1 from "../../../assets/products/SWITCH_1.png";
import REPEATER_1 from "../../../assets/products/REPEATER_1.png";
import THERMOSTAT_1W from "../../../assets/products/THERMOSTAT_1W.png";
import OPEN_1 from "../../../assets/products/OPEN_1.png";
import MOTIONLIGHT_1 from "../../../assets/products/MOTIONLIGHT_1.png";
import ENERGY1PN_1 from "../../../assets/products/ENERGY1PN_1.png";
import textContentSmarthomeProductSection from "../../smarthome/ui/textContent-smarthome-ProductSection";

export default function MadeInFranceSection(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  const productMeta = (productKey, image) => {
    return {
      title:
        textContentSmarthomeProductSection.productSection.items.products
          .productsList[productKey].subtitle[language],
      subtitle:
        textContentSmarthomeProductSection.productSection.items.products
          .productsList[productKey].description[language],
      image,
      productURL:
        textContentSmarthomeProductSection.productSection.items.products
          .productsList[productKey].link,
    };
  };

  return (
    <section className="container">
      {!isMobile ? (
        <div className="madeInFrance">
          <div className="madeInFrance-image">
            <img src={madeInFranceImage} alt="" />
          </div>
          <div className="madeInFrance-text">
            <h1 className="title-gradient madeInFrance-text-container">
              {textContent.madeInFrance.title[language]}
            </h1>
            <div className={`french-flag ${isMobile ? "mobile" : ""}`}>
              <div className="french-flag-left"></div>
              <div className="french-flag-middle"></div>
              <div className="french-flag-right"></div>
            </div>
            <div className="container-empty-extra-small" />
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.madeInFrance.description.description1[language],
              }}
            />
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.madeInFrance.description.description2[language],
              }}
            />
          </div>
        </div>
      ) : (
        <div className="madeInFrance-mobile">
          <div className="madeInFrance-text">
            <h1 className="title-gradient madeInFrance-text-container">
              {textContent.madeInFrance.title[language]}
            </h1>
            <div className={`french-flag ${isMobile ? "mobile" : ""}`}>
              <div className="french-flag-left"></div>
              <div className="french-flag-middle"></div>
              <div className="french-flag-right"></div>
            </div>
            <div className="container-empty-extra-small" />
          </div>
          <div className="madeInFrance-image-mobile">
            <img src={madeInFranceImage} alt="" />
          </div>
          <div className="container-empty-extra-small" />
          <div className="madeInFrance-text">
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.madeInFrance.description.description1[language],
              }}
            />
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.madeInFrance.description.description2[language],
              }}
            />
          </div>
        </div>
      )}
      {!isMobile ? <div className="container-empty-small" /> : null}
      <ProductCarousel
        products={[
          <ProductCard {...productMeta("CONTROLLERDIN_1", CONTROLLERDIN_1)} />,
          <ProductCard
            {...productMeta("MULTISWITCHDIN_1", MULTISWITCHDIN_1)}
          />,
          <ProductCard {...productMeta("SWITCHDIN_1", SWITCHDIN_1)} />,
          <ProductCard {...productMeta("MULTISWITCH_1", MULTISWITCH_1)} />,
          <ProductCard {...productMeta("MULTISWITCH_2", MULTISWITCH_2)} />,
          <ProductCard {...productMeta("SWITCH_1", SWITCH_1)} />,
          <ProductCard {...productMeta("THERMOSTAT_1W", THERMOSTAT_1W)} />,
          <ProductCard {...productMeta("COMMAND_1", COMMAND_1)} />,
          <ProductCard {...productMeta("OPEN_1", OPEN_1)} />,
          <ProductCard {...productMeta("MOTIONLIGHT_1", MOTIONLIGHT_1)} />,
          <ProductCard {...productMeta("ENERGY1PN_1", ENERGY1PN_1)} />,
          <ProductCard {...productMeta("REPEATER_1", REPEATER_1)} />,
        ]}
      />
    </section>
  );
}
